/*@ngInject*/
module.exports = function homeController() {
    const vm = this;

    vm.viewMode = "main";
    vm.objectAreaModalOpened = false;
    vm.filter = {};
};


/** WEBPACK FOOTER **
 ** ./app/shared/controllers/home.controller.js
 **/